import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcExpandable } from '@one/react';

export type PocExpandableProps = ComponentPropsWithoutRef<typeof OwcExpandable>;

export const PocExpandable = forwardRef<ElementRef<typeof OwcExpandable>, PocExpandableProps>((props, ref) => (
    <OwcExpandable ref={ref} {...props} />
));

PocExpandable.displayName = 'PocExpandable';
